import { Component, Inject } from '@angular/core';
import { FormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import {
  MAT_DIALOG_DATA,
  MatDialog,
  MatDialogRef,
} from '@angular/material/dialog';
import { Router } from '@angular/router';
import { UserApiService } from 'src/app/services/api/user-api.service';
import { MessageService } from 'src/app/services/message.service';
import { WorkorderAfterSales4ModalComponent } from '../workorder-after-sales4-modal/workorder-after-sales4-modal.component';

@Component({
  selector: 'app-workorder-after-sales3-modal',
  templateUrl: './workorder-after-sales3-modal.component.html',
  styleUrls: ['./workorder-after-sales3-modal.component.scss'],
})
export class WorkorderAfterSales3ModalComponent {
  formGroup: UntypedFormGroup;
  constructor(
    private dialogRef: MatDialogRef<WorkorderAfterSales3ModalComponent>,
    private dialog: MatDialog,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private api: UserApiService,
    private fb: FormBuilder,
    private message: MessageService,
    private router: Router
  ) {
    this.formGroup = this.fb.group({
      detail: ['', [Validators.required]],
      icon: ['', []],
    });
  }

  close(r: any = null) {
    this.dialogRef.close(r);
  }

  loading = false;
  async reply() {
    if (!this.formGroup.value.detail) {
      this.message.warn('请填写内容', { position: 'top' });
      return;
    }
    try {
      this.loading = true;
      const r = await this.api.createWorkPrblemdetail(
        this.data.bus_id,
        this.data.bus_seat_id,
        this.data.platform_id,
        this.data.bus_account_id,
        this.data.order_id,
        this.data.id,
        this.formGroup.value.icon,
        this.formGroup.value.detail
      );
      if (r.status === 0) {
        this.close('ok');
        this.dialog.open(WorkorderAfterSales4ModalComponent, {
          data: this.data,
        });
      } else if (r.status === 1) {
        this.message.warn('工单重复提交');
        this.router
          .navigateByUrl('/', { skipLocationChange: true })
          .then(() => {
            this.router.navigate(['/user/profile/seats']);
          });
      } else {
        this.message.warn('未知错误');
      }
    } catch (error) {
    } finally {
      this.loading = false;
    }
  }
}
